import { Actions, thunk } from 'easy-peasy';
import extractFullName from '~/utils/text/extractFullName';
import api from '~/services/api';
import { IClientActions, IClientStore, IThunkRestoreClient } from '../types';

const onRestoreClient: IThunkRestoreClient = thunk(
  async (
    { setClients, setClientOptionsByTeam }: Actions<IClientActions>,
    payload,
    { getState },
  ) => {
    const localState = getState() as IClientStore;

    await api.clientTeams.restoreTeam(payload);

    const updatedList = localState.list.map(item =>
      String(item.id) !== payload.clientId ? item : { ...item, isArchived: false },
    );

    const restoredClient = localState.list.find(item => String(item.id) === payload.clientId);

    setClients({ items: updatedList });

    if (restoredClient) {
      setClientOptionsByTeam({
        items: [
          ...localState.clientOptionsByTeam.list,
          {
            id: restoredClient.id,
            name: extractFullName(restoredClient),
            photo: restoredClient.photo,
            teams: restoredClient.teams.map(t => ({
              id: t.team.id,
              name: t.team.name,
              isPrimary: t.isPrimary,
              isArchived: t.isArchived,
            })),
            firstName: restoredClient.firstName,
            lastName: restoredClient.lastName,
          },
        ],
        archived: localState.clientOptionsByTeam.excluded.filter(
          item => item !== Number(payload.clientId),
        ),
      });
    }
  },
);

export default onRestoreClient;
